import axios from 'axios';

class Api {
  apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  async get(endpoint: string, params?: any) {
    return axios
      .get(`${this.apiUrl}${endpoint}`, { params })
      .then((response) => response.data);
  }
}

export default Api;
